import React from 'react';
import { AssetForm } from '../../components/logistics/AssetForm';

export const AssetFormPage = ({ user }: { user: any }) => (
  <div className="p-4 md:p-6">
    <div className="mb-5">
      <h1 className="text-2xl font-bold text-white mb-1">Gestion de la Logistique et des Actifs</h1>
      <p className="text-gray-400 text-sm">Enregistrement · Inspection mécanique · Suivi opérationnel · Déclassement</p>
    </div>
    <AssetForm user={user} />
  </div>
);
